/**
 * @generated SignedSource<<2665317f2409e00112d4a78e8a2ae513>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type AppDialogConnectionDataTable_appDialogConnection$data = {
  readonly edges: ReadonlyArray<{
    readonly node: {
      readonly createdBy: {
        readonly " $fragmentSpreads": FragmentRefs<"UserAvatarText_user">;
      };
      readonly endAt: any;
      readonly id: string;
      readonly order: number;
      readonly sequence: number;
      readonly startAt: any;
      readonly title: string;
      readonly " $fragmentSpreads": FragmentRefs<"AppDialogStatusLabel_appDialog">;
    };
  }>;
  readonly " $fragmentType": "AppDialogConnectionDataTable_appDialogConnection";
};
export type AppDialogConnectionDataTable_appDialogConnection$key = {
  readonly " $data"?: AppDialogConnectionDataTable_appDialogConnection$data;
  readonly " $fragmentSpreads": FragmentRefs<"AppDialogConnectionDataTable_appDialogConnection">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "AppDialogConnectionDataTable_appDialogConnection",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "AppDialogEdge",
      "kind": "LinkedField",
      "name": "edges",
      "plural": true,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "AppDialog",
          "kind": "LinkedField",
          "name": "node",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "id",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "title",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "sequence",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "startAt",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "endAt",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "order",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "concreteType": "User",
              "kind": "LinkedField",
              "name": "createdBy",
              "plural": false,
              "selections": [
                {
                  "args": null,
                  "kind": "FragmentSpread",
                  "name": "UserAvatarText_user"
                }
              ],
              "storageKey": null
            },
            {
              "args": null,
              "kind": "FragmentSpread",
              "name": "AppDialogStatusLabel_appDialog"
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "AppDialogConnection",
  "abstractKey": null
};

(node as any).hash = "bd6db176d009b3beb0e6090fc74dddf9";

export default node;
